<template>
    <div>
        <div class="alert-bar">
            <p>
                Clinique dentaire Iberville et Centre dentaire Dominique Laroche deviennent Votre Dentisterie
            </p>
        </div>

        <section class="top-nav">
            <div class="col">
                <p class="small-text hours">
                    <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.5 0.00029467C9.9194 0.00029467 6.48608 1.42242 3.9535 3.95376C1.42217 6.48622 0 9.91959 0 13.5001C0 17.0807 1.42214 20.514 3.9535 23.0465C6.48599 25.5779 9.9194 27 13.5 27C17.0806 27 20.5139 25.5779 23.0465 23.0465C25.5778 20.5141 27 17.0807 27 13.5001C26.9965 9.92077 25.5721 6.48954 23.0418 3.95817C20.5104 1.42804 17.0794 0.00353461 13.4997 0L13.5 0.00029467ZM13.5 24.5458C10.5706 24.5458 7.76091 23.3826 5.6896 21.3105C3.61736 19.2394 2.45422 16.4298 2.45422 13.5001C2.45422 10.5705 3.61748 7.76112 5.6896 5.68984C7.76067 3.61761 10.5704 2.45449 13.5 2.45449C16.4296 2.45449 19.2391 3.61773 21.3104 5.68984C23.3826 7.76088 24.5458 10.5705 24.5458 13.5001C24.5423 16.4284 23.3779 19.2359 21.3069 21.3069C19.2358 23.3779 16.4285 24.5423 13.5 24.5458ZM17.8388 16.104C18.0747 16.3329 18.2093 16.6471 18.2116 16.9761C18.2139 17.304 18.0839 17.6204 17.8514 17.8529C17.619 18.0853 17.3037 18.2142 16.9746 18.2119C16.6456 18.2096 16.3315 18.075 16.1037 17.8391L12.6335 14.3678H12.6324C12.4045 14.1388 12.2757 13.8293 12.2734 13.506L12.2722 13.5003V8.59068C12.2722 7.91298 12.8222 7.36414 13.4999 7.36414C14.1776 7.36414 14.7276 7.91298 14.7276 8.59068V12.9916L17.8388 16.104Z"
                            fill="#F2F9F7"
                        />
                    </svg>
                    <span v-if="globalsIsLoaded && (globals.cliniquesItems.data[0].heures[new Date().getDay()].value === 'Closed' || globals.cliniquesItems.data[0].heures[new Date().getDay()].value === 'Fermé')"
                        >{{ $t(globals.cliniquesItems.data[0].heures[new Date().getDay()].day) }} -
                        {{ globals.cliniquesItems.data[0].heures[new Date().getDay()].value }}</span
                    >
                    <span v-else-if="globalsIsLoaded && new Date().getHours() < 12"
                        >{{ $t(globals.cliniquesItems.data[0].heures[new Date().getDay()].day) }} -
                        {{ $t('Ouvert de') }}
                        {{ globals.cliniquesItems.data[0].heures[new Date().getDay()].value }}</span
                    >
                    <span v-else-if="globalsIsLoaded && new Date().getHours() >= 12"
                        >{{ $t(globals.cliniquesItems.data[0].heures[new Date().getDay()].day) }} -
                        {{ $t('Ouvert jusqu’à') }}
                        {{ globals.cliniquesItems.data[0].heures[new Date().getDay()].end }}</span
                    >
                </p>
            </div>
            <div class="col">
                <a v-if="$route.meta.lang === 'fr'" class="regular-text lang" :href="urls['en'] ? urls['en'] : ''" title="English"
                    >En<span class="no-mobile">glish</span></a
                >
                <a v-else class="regular-text lang" :href="urls['fr'] ? urls['fr'] : ''" title="Français"
                    >Fr<span class="no-mobile">ançais</span></a
                >
                <a class="medium-text phone" :href="'tel:' + globals.header[0].telephonePrincipal" v-if="globalsIsLoaded">{{
                    globals.header[0].telephonePrincipal
                }}</a>
            </div>
        </section>

        <nav class="main-nav" @click="closeAfterClick()">
            <router-link
                :to="{ name: 'HomePage-' + $route.meta.lang }"
                class="logo-link"
                href="#"
                alt="Votre Dentisterie St-Jean-sur-Richelieu"
                title=""
            >
                <svg
                    class="logo"
                    role="img"
                    height="55"
                    viewBox="0 0 77 70"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.06 50.0901C0.84 50.5501 1.59 51.0401 2.33 51.5201C3.07 52.0001 3.86 52.4301 4.6 52.8901L6.88 54.1701C7.65 54.5901 8.42 54.9701 9.19 55.3701C12.2262 56.8947 15.3716 58.1916 18.6 59.2501C24.9258 61.315 31.5357 62.3778 38.19 62.4001C44.8469 62.3896 51.4609 61.3334 57.79 59.2701C61.0224 58.2135 64.1711 56.9165 67.21 55.3901C67.97 55.0001 68.75 54.6101 69.52 54.2001L71.8 52.9101C72.55 52.4501 73.32 52.0101 74.07 51.5501C74.82 51.0901 75.57 50.5501 76.35 50.1101C75.86 50.8701 75.35 51.6001 74.79 52.3301C74.23 53.0601 73.64 53.7401 73.05 54.4301C72.46 55.1201 71.8 55.7501 71.16 56.4301C70.85 56.7701 70.5 57.0501 70.16 57.3701L69.16 58.2901C66.3455 60.7003 63.2456 62.7557 59.93 64.4101C59.52 64.6301 59.09 64.8101 58.67 65.0101L57.39 65.5901C56.97 65.7901 56.53 65.9301 56.09 66.1101L54.78 66.6101C53.9 66.9301 53.01 67.2001 52.11 67.4901C51.21 67.7801 50.3 67.9701 49.39 68.2101C45.7242 69.0611 41.9733 69.4906 38.21 69.4901C30.6726 69.5088 23.2338 67.7766 16.48 64.4301C13.1631 62.7779 10.0629 60.7223 7.25 58.3101L6.25 57.3901C5.92 57.0801 5.56 56.7901 5.25 56.4601C4.61 55.7901 3.96 55.1601 3.36 54.4601C2.76 53.7601 2.18 53.0701 1.62 52.3601C1.06 51.6501 0.5 50.8901 0 50.1401L0.06 50.0901Z"
                        fill="#89AEAC"
                    />
                    <path
                        d="M29.9999 19.1999C29.809 18.8397 29.7637 18.4198 29.8735 18.0271C29.9833 17.6344 30.2398 17.2989 30.5899 17.0899C31.4984 16.571 32.5611 16.3904 33.5899 16.5799C34.0041 17.7962 34.2037 19.0753 34.1799 20.3599C34.1478 21.7741 33.8244 23.1664 33.2299 24.4499L27.5699 37.4499C27.5664 37.4913 27.5488 37.5301 27.5199 37.5599C27.1399 38.4799 26.8799 39.1799 26.7399 39.6399C26.603 40.1515 26.569 40.6851 26.6399 41.2099H19.3099L10.6099 20.9999C10.2901 20.2508 9.9296 19.5197 9.52994 18.8099C9.14994 18.1399 8.70994 17.4199 8.18994 16.6299H15.9099C16.0376 17.3358 16.2181 18.0311 16.4499 18.7099C16.6799 19.3499 16.9799 20.0799 17.3599 20.8999L25.5399 39.6899L31.6199 25.7399C32.086 24.8459 32.2542 23.8263 32.0999 22.8299C31.8969 21.9983 31.5222 21.2182 30.9999 20.5399C30.7611 20.3486 30.5522 20.1228 30.3799 19.8699C30.218 19.6685 30.0897 19.4423 29.9999 19.1999Z"
                        fill="#89AEAC"
                    />
                    <path
                        d="M60.13 41.18C59.89 39.5 59.75 38.08 59.7 36.91C59.65 35.74 59.62 34.1 59.62 31.97V10.4C59.62 8.4 59.62 6.71 59.52 5.4C59.42 4.09 59.28 2.3 59 0H65.74V31.09C65.74 33.09 65.79 34.77 65.87 36.04C65.95 37.31 66.19 39.04 66.57 41.18H60.13ZM51 17C49.9294 16.995 48.8777 17.282 47.958 17.8299C47.0382 18.3779 46.2852 19.1662 45.78 20.11C44.49 22.19 43.85 25.11 43.85 28.89C43.7174 31.8322 44.3734 34.7563 45.75 37.36C46.3336 38.3876 47.1919 39.2322 48.2288 39.7992C49.2656 40.3662 50.4399 40.6331 51.62 40.57C53.1436 40.6011 54.6358 40.1342 55.87 39.24C57.1437 38.2592 58.1143 36.9385 58.67 35.43C59.3629 33.5866 59.7022 31.6291 59.67 29.66H60.39C60.416 31.8061 60.0324 33.9375 59.26 35.94C58.546 37.7733 57.3122 39.3582 55.71 40.5C53.899 41.7051 51.7535 42.307 49.58 42.22C47.4137 42.2523 45.2733 41.7472 43.35 40.75C41.451 39.731 39.8932 38.1767 38.87 36.28C37.6742 34.005 37.0885 31.4589 37.17 28.89C37.0925 26.3339 37.6891 23.8024 38.9 21.55C39.9083 19.6587 41.4209 18.0838 43.27 17C45.0428 16.0124 47.0406 15.4992 49.07 15.51C51.1403 15.5018 53.1794 16.0141 55 17C56.7981 17.9715 58.3828 19.2944 59.66 20.89V22.23C58.5637 20.7517 57.2084 19.4846 55.66 18.49C54.2831 17.5537 52.6646 17.0362 51 17Z"
                        fill="#565B6E"
                    />
                </svg>
            </router-link>

            <div class="nav-links">
                <router-link
                    :to="{ name: 'CliniquesIndex-' + $route.meta.lang }"
                    class="nav-link"
                    :class="{ 'is-active': $route.name && $route.name.includes('Cliniques') }"
                    title="Cliniques"
                >
                    {{ $t('Cliniques') }}
                    <svg
                        class="icon"
                        height="7"
                        viewBox="0 0 34 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.0104445 0C2.56971 1.79653 5.34758 3.22789 8.27027 4.25606C13.9406 6.20322 20.0594 6.20322 25.7297 4.25606C28.6558 3.22806 31.4371 1.79672 34 0C32.16 2.84017 29.64 5.12844 26.6904 6.6375C23.6817 8.19153 20.37 9 17.0131 9C13.6561 9 10.3444 8.19153 7.33569 6.6375C4.37593 5.13841 1.84605 2.85308 0 0.0108972L0.0104445 0Z"
                            fill="#89AEAC"
                        />
                    </svg>
                </router-link>
                <router-link
                    :to="{ name: 'TraitementsIndex-' + $route.meta.lang }"
                    :class="{ 'is-active': $route.name && $route.name.includes('Traitements') }"
                    class="nav-link"
                    title="Traitements"
                >
                    {{ $t('Soins dentaires') }}
                    <svg
                        class="icon"
                        height="7"
                        viewBox="0 0 34 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.0104445 0C2.56971 1.79653 5.34758 3.22789 8.27027 4.25606C13.9406 6.20322 20.0594 6.20322 25.7297 4.25606C28.6558 3.22806 31.4371 1.79672 34 0C32.16 2.84017 29.64 5.12844 26.6904 6.6375C23.6817 8.19153 20.37 9 17.0131 9C13.6561 9 10.3444 8.19153 7.33569 6.6375C4.37593 5.13841 1.84605 2.85308 0 0.0108972L0.0104445 0Z"
                            fill="#89AEAC"
                        />
                    </svg>
                </router-link>
                <router-link
                    :to="{ name: 'RessourcesIndex-' + $route.meta.lang }"
                    :class="{ 'is-active': $route.name && $route.name.includes('Ressources') }"
                    class="nav-link"
                    title="Ressources"
                >
                    {{ $t('Ressources') }}
                    <svg
                        class="icon"
                        height="7"
                        viewBox="0 0 34 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.0104445 0C2.56971 1.79653 5.34758 3.22789 8.27027 4.25606C13.9406 6.20322 20.0594 6.20322 25.7297 4.25606C28.6558 3.22806 31.4371 1.79672 34 0C32.16 2.84017 29.64 5.12844 26.6904 6.6375C23.6817 8.19153 20.37 9 17.0131 9C13.6561 9 10.3444 8.19153 7.33569 6.6375C4.37593 5.13841 1.84605 2.85308 0 0.0108972L0.0104445 0Z"
                            fill="#89AEAC"
                        />
                    </svg>
                </router-link>
                <router-link
                    :to="{ name: 'About-' + $route.meta.lang }"
                    :class="{ 'is-active': $route.name && $route.name === 'About-' + $route.meta.lang }"
                    class="nav-link"
                    title="À propos"
                >
                    {{ $t('À propos') }}
                    <svg
                        class="icon"
                        height="7"
                        viewBox="0 0 34 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.0104445 0C2.56971 1.79653 5.34758 3.22789 8.27027 4.25606C13.9406 6.20322 20.0594 6.20322 25.7297 4.25606C28.6558 3.22806 31.4371 1.79672 34 0C32.16 2.84017 29.64 5.12844 26.6904 6.6375C23.6817 8.19153 20.37 9 17.0131 9C13.6561 9 10.3444 8.19153 7.33569 6.6375C4.37593 5.13841 1.84605 2.85308 0 0.0108972L0.0104445 0Z"
                            fill="#89AEAC"
                        />
                    </svg>
                </router-link>
                <router-link
                    :to="{ name: 'Careers-' + $route.meta.lang }"
                    :class="{ 'is-active': $route.name && $route.name === 'Careers-' + $route.meta.lang }"
                    class="nav-link"
                    title="Carrières"
                >
                    {{ $t('Carrières') }}
                    <svg
                        class="icon"
                        height="7"
                        viewBox="0 0 34 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.0104445 0C2.56971 1.79653 5.34758 3.22789 8.27027 4.25606C13.9406 6.20322 20.0594 6.20322 25.7297 4.25606C28.6558 3.22806 31.4371 1.79672 34 0C32.16 2.84017 29.64 5.12844 26.6904 6.6375C23.6817 8.19153 20.37 9 17.0131 9C13.6561 9 10.3444 8.19153 7.33569 6.6375C4.37593 5.13841 1.84605 2.85308 0 0.0108972L0.0104445 0Z"
                            fill="#89AEAC"
                        />
                    </svg>
                </router-link>
            </div>

            <a
                class="site-btn nav-cta alternate"
                href="#"
                :title="$t('Prendre rendez-vous')"
                @click.prevent="togglePanel('rendez-vous')"
                >{{ $t('Prendre rendez-vous') }}</a
            >

            <div
                id="hamburger"
                @click.prevent.stop="
                    () => {
                        mobileMenuOpen = !mobileMenuOpen
                    }
                "
                :class="{ open: mobileMenuOpen }"
            >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </nav>

        <!-- Floating Logo -->
        <router-link :to="{ name: 'HomePage-' + $route.meta.lang }" class="floating-logo-wrapper">
            <FloatingLogo />
        </router-link>

        <!-- Mobile Menu -->
        <div class="mobile-menu-wrap" :class="{ open: mobileMenuOpen }">
            <nav @click="closeAfterClick()">
                <router-link
                    :to="{ name: 'CliniquesIndex-' + $route.meta.lang }"
                    class="nav-link"
                    :class="{ 'is-active': $route.name && $route.name === 'CliniquesIndex-' + $route.meta.lang }"
                    title="Cliniques"
                >
                    {{ $t('Cliniques') }}
                </router-link>
                <router-link
                    :to="{ name: 'TraitementsIndex-' + $route.meta.lang }"
                    :class="{ 'is-active': $route.name && $route.name === 'TraitementsIndex-' + $route.meta.lang }"
                    class="nav-link"
                    title="Traitements"
                >
                    {{ $t('Soins dentaires') }}
                </router-link>
                <router-link
                    :to="{ name: 'RessourcesIndex-' + $route.meta.lang }"
                    :class="{ 'is-active': $route.name && $route.name === 'RessourcesIndex-' + $route.meta.lang }"
                    class="nav-link"
                    title="Ressources"
                >
                    {{ $t('Ressources') }}
                </router-link>
                <router-link
                    :to="{ name: 'About-' + $route.meta.lang }"
                    :class="{ 'is-active': $route.name && $route.name === 'About-' + $route.meta.lang }"
                    class="nav-link"
                    title="À propos"
                >
                    {{ $t('À propos') }}
                </router-link>
                <router-link
                    :to="{ name: 'Careers-' + $route.meta.lang }"
                    :class="{ 'is-active': $route.name && $route.name === 'Careers-' + $route.meta.lang }"
                    class="nav-link"
                    title="Carrières"
                >
                    {{ $t('Carrières') }}
                </router-link>
            </nav>
            <a
                href="#contact"
                class="site-btn alternate"
                @click.prevent="togglePanel('rendez-vous')"
            >
                {{ $t('Prendre rendez-vous') }}
            </a>
            <div class="social" v-if="globalsIsLoaded">
                <a :href="globals.footer[0].reseaux.facebook" title="Facebook link" target="_blank" rel="noopener noreferrer">
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM22.0846 20.8785V31.7596H17.5825V20.8789H15.3333V17.1293H17.5825V14.878C17.5825 11.819 18.8526 10 22.461 10H25.465V13.7501H23.5873C22.1826 13.7501 22.0897 14.2741 22.0897 15.2521L22.0846 17.1288H25.4863L25.0882 20.8785H22.0846Z"
                            fill="#F2F9F7"
                        />
                    </svg>
                </a>
                <a :href="globals.footer[0].reseaux.instagram" title="Instagram link" target="_blank" rel="noopener noreferrer">
                    <svg width="40" height="40" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.413818 22.0563C0.413818 9.87492 10.2887 0 22.4701 0C34.6514 0 44.5263 9.87492 44.5263 22.0563C44.5263 34.2376 34.6514 44.1125 22.4701 44.1125C10.2887 44.1125 0.413818 34.2376 0.413818 22.0563Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.471 10.293C19.2762 10.293 18.8753 10.3069 17.6205 10.364C16.3682 10.4214 15.5134 10.6196 14.7654 10.9106C13.9917 11.211 13.3354 11.6129 12.6816 12.267C12.0272 12.9209 11.6253 13.5772 11.3239 14.3506C11.0322 15.0988 10.8337 15.9539 10.7774 17.2057C10.7212 18.4605 10.7065 18.8617 10.7065 22.0564C10.7065 25.2512 10.7208 25.6509 10.7776 26.9057C10.8352 28.158 11.0335 29.0128 11.3241 29.7608C11.6248 30.5345 12.0267 31.1908 12.6808 31.8446C13.3345 32.4989 13.9908 32.9018 14.764 33.2023C15.5124 33.4932 16.3675 33.6915 17.6195 33.7488C18.8743 33.8059 19.275 33.8199 22.4695 33.8199C25.6645 33.8199 26.0642 33.8059 27.319 33.7488C28.5713 33.6915 29.4271 33.4932 30.1756 33.2023C30.949 32.9018 31.6043 32.4989 32.2579 31.8446C32.9123 31.1908 33.3142 30.5345 33.6156 29.761C33.9048 29.0128 34.1033 28.1577 34.1621 26.9059C34.2185 25.6511 34.2332 25.2512 34.2332 22.0564C34.2332 18.8617 34.2185 18.4607 34.1621 17.206C34.1033 15.9536 33.9048 15.0988 33.6156 14.3509C33.3142 13.5772 32.9123 12.9209 32.2579 12.267C31.6036 11.6127 30.9493 11.2108 30.1748 10.9106C29.4249 10.6196 28.5696 10.4214 27.3173 10.364C26.0625 10.3069 25.663 10.293 22.4673 10.293H22.471ZM22.0785 12.4129H22.0788L22.4708 12.413C25.6117 12.413 25.984 12.4243 27.2243 12.4806C28.3712 12.5331 28.9937 12.7247 29.4084 12.8857C29.9573 13.099 30.3487 13.3538 30.7602 13.7656C31.1719 14.1773 31.4268 14.5694 31.6405 15.1183C31.8015 15.5325 31.9934 16.155 32.0456 17.3019C32.1019 18.542 32.1142 18.9145 32.1142 22.0539C32.1142 25.1933 32.1019 25.5658 32.0456 26.8058C31.9931 27.9528 31.8015 28.5753 31.6405 28.9894C31.4273 29.5384 31.1719 29.9293 30.7602 30.3408C30.3484 30.7525 29.9576 31.0074 29.4084 31.2206C28.9942 31.3823 28.3712 31.5735 27.2243 31.6259C25.9842 31.6823 25.6117 31.6945 22.4708 31.6945C19.3298 31.6945 18.9575 31.6823 17.7174 31.6259C16.5705 31.573 15.948 31.3813 15.5331 31.2203C14.9841 31.0071 14.592 30.7522 14.1803 30.3405C13.7686 29.9288 13.5137 29.5377 13.3 28.9884C13.139 28.5743 12.9471 27.9518 12.8949 26.8049C12.8385 25.5648 12.8273 25.1923 12.8273 22.0509C12.8273 18.9096 12.8385 18.5391 12.8949 17.299C12.9473 16.1521 13.139 15.5296 13.3 15.1149C13.5132 14.566 13.7686 14.1738 14.1803 13.7621C14.592 13.3504 14.9841 13.0955 15.5331 12.8818C15.9478 12.7201 16.5705 12.5289 17.7174 12.4762C18.8026 12.4272 19.2232 12.4125 21.4156 12.4101V12.413C21.6204 12.4127 21.8407 12.4128 22.0785 12.4129ZM27.3385 15.7772C27.3385 14.9976 27.9708 14.3661 28.7502 14.3661V14.3656C29.5295 14.3656 30.1618 14.9979 30.1618 15.7772C30.1618 16.5565 29.5295 17.1888 28.7502 17.1888C27.9708 17.1888 27.3385 16.5565 27.3385 15.7772ZM22.4706 16.0152C19.1346 16.0153 16.4298 18.7201 16.4298 22.0562C16.4298 25.3924 19.1347 28.096 22.4709 28.096C25.807 28.096 28.5109 25.3924 28.5109 22.0562C28.5109 18.72 25.8068 16.0152 22.4706 16.0152ZM26.3921 22.0566C26.3921 19.8909 24.6364 18.1354 22.4709 18.1354C20.3052 18.1354 18.5498 19.8909 18.5498 22.0566C18.5498 24.222 20.3052 25.9777 22.4709 25.9777C24.6364 25.9777 26.3921 24.222 26.3921 22.0566Z" fill="#F2F9F7" class="light" />
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FloatingLogo from '@/components/FloatingLogo.vue'

export default {
    name: 'NavBar',

    components: {
        FloatingLogo,
    },

    data() {
        return {
            mobileMenuOpen: false,
        }
    },

    methods: {
        closeAfterClick() {
            setTimeout(() => {
                this.mobileMenuOpen = false
            }, 55)
        },
        ...mapActions(['togglePanel']),
    },

    computed: {
        ...mapState(['panelIsOpen', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'urls', 'globals']),
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
